import { Chess } from "chessops/chess";
import { makeFen, parseFen } from "chessops/fen";
import { parseSan } from "chessops/san";

export const generatePositionFen = ({
    startingPosition,
    sanPlies,
    plyIndex,
}: {
    startingPosition: string;
    sanPlies: string[];
    plyIndex: number;
}) => {
    const setup = parseFen(startingPosition).unwrap();
    const chessGame = Chess.fromSetup(setup).unwrap();

    for (let i = 0; sanPlies[i] !== undefined && i < plyIndex + 1; i++) {
        const move = parseSan(chessGame, sanPlies[i]);

        if (!move) {
            throw new Error(`Invalid move: ${sanPlies[i]}`);
        }

        chessGame.play(move);
    }

    return makeFen(chessGame.toSetup());
};
